import React, { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { connect } from 'react-redux'
import { sortBy } from 'lodash'
import Sprite from '~components/Sprite'
import { loadCart } from '~redux/shop'
import Button from '~components/ui/Button'

class QuickOrder extends Component {
  constructor (props) {
    super(props)

    this.state = {
      busy: false,
      file: '',
      errors: null
    }

    this.submit = this.submit.bind(this)
  }

  submit () {
    if (this.state.busy || !this.state.file) {
      return
    }

    this.setState({ busy: true })

    const data = new FormData()
    data.append('file', this.state.file)

    axios.post('/api/cart/import', data).then(response => {
      alert('import successful.')
    }).catch(error => {
      if (error.response && error.response.status === 422) {
        this.setState({
          errors: error.response.data
        })
      }
    }).finally(() => {
      this.setState({ busy: false })
      this.props.dispatch(loadCart())
    })
  }

  handleFileChange (e) {
    this.setState({
      file: e.target.files[0]
    })
  }

  render () {
    let errors = []

    if (this.state.errors) {
      Object.keys(this.state.errors.errors).forEach(key => {
        this.state.errors.errors[key].forEach(message => {
          let row = null

          if (/^\d+\./.test(key)) {
            row = parseInt(key.split('.', 2)[0]) + 2 // + 2 because it's 0 based and ignores the header row
          }

          errors.push({
            key,
            row,
            message: message
          })
        })
      })

      errors = sortBy(errors, 'row')
    }

    return (
      <div className="fixed z-50 p-4 md:p-8 flex flex-col top-0 left-0 right-0 bottom-0 bg-charcoal bg-opacity-75">
        <div className="bg-white sm:bg-lightGrey w-full m-auto max-w-screen-mdxl px-4 py-8 sm:p-15 sm:pb-0 overflow-scrolling overflow-x-hidden overflow-y-auto relative">
          <button type="button" className="w-10 h-10 absolute top-3 right-1 sm:top-8 sm:right-7 block" aria-label="Close" onClick={this.props.onClose}>
            <span className="w-4 h-4 icon icon-fill block m-auto" aria-hidden="true">
              <Sprite name="cross" />
            </span>
          </button>

          <h3 className="text-md lg:text-2xl border-b border-coral pb-6">
            Quick order
          </h3>

          <div className="mt-7 w-full sm:w-1/2">
            <label className="w-full block" htmlFor="quick-order-file">
              Select file
            </label>

            <span className="w-full relative block mt-4">
              <input
                type="file"
                accept=".csv"
                onChange={this.handleFileChange.bind(this)}
                className="cursor-pointer absolute top-0 left-0 right-0 bottom-0 appearance-none opacity-0 z-20 w-full"
                id="quick-order-file"
              />

              <Button
                theme="secondary"
                className="z-10 relative w-full"
              >
                Browse file
              </Button>

              {this.state.file?.name && (
                <span className="block mt-4">
                  {this.state.file.name}
                </span>
              )}
            </span>

            <a href={`${window.Panache.storageUrl}panache_quickorder_template.csv`} className="mt-6 block md:mt-8 underline hover:no-underline focus:no-underline">
              Download CSV Template
            </a>
          </div>

          {errors.length > 0 &&
            <>
              <p>
                {this.state.errors.message}
              </p>

              <div className="bg-white mt-7 h-32 overflow-y-scroll">
                <table>
                  <tbody>
                    {errors.map(error => (
                      <tr key={`${error.key}_${error.message}`}>
                        {error.row &&
                        <th className="p-2">
                          Row
                          {' '}
                          {error.row}
                          :
                        </th>}
                        <td className="p-2">
                          {error.message}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>}

          <div className="mt-12 flex flex-wrap -mx-2 sm:bg-white sm:py-8 relative before:bg-white after:bg-white before:-left-max after:-right-max content-after content-before sm:content-before sm:content-after before:absolute after:absolute before:w-max after:w-max before:top-0 after:top-0 before:h-full after:h-full" tw-content-before="" tw-content-after="">
            <div className="w-full px-2 my-2 sm:w-1/2">
              <Button
                theme="black-to-red"
                className="w-full"
                onClick={this.props.onClose}
              >
                Cancel
              </Button>
            </div>

            <div className="w-full px-2 my-2 sm:w-1/2">
              <Button
                onClick={this.submit}
                theme="green-to-pink"
                className="w-full"
              >
                Confirm
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

QuickOrder.propTypes = {
  onClose: PropTypes.func,
  className: PropTypes.string,
  dispatch: PropTypes.func
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(null, mapDispatchToProps)(QuickOrder)
